export default __webpack_public_path__ + "static/media/avatar_49.b06e3f8b.png";